import React from 'react';
import { BsInstagram, BsLinkedin } from 'react-icons/bs';
// import { FaFacebook } from 'react-icons/fa'

const SocialMedia = () => {
    return (
        <div className='app__social'>
            <div>
                <a href='https://www.instagram.com/asad_1071_/' target='_blank' rel='noopener noreferrer'>
                    <BsInstagram />
                </a>
            </div>
            <div>
                <a href='https://www.linkedin.com/in/asad1021/' target='_blank' rel='noopener noreferrer'>
                    <BsLinkedin />
                </a>
            </div>
            {/* Uncomment and add your Facebook link if needed */}
            {/* <div>
                <a href='https://www.facebook.com/your_profile' target='_blank' rel='noopener noreferrer'>
                    <FaFacebook />
                </a>
            </div> */}
        </div>
    );
};

export default SocialMedia;
